module.exports = {
      id: "padlock-alt-usage",
      viewBox: "0 0 30 30",
      url: "img/" + "sprite.svg#padlock-alt-usage",
      toString: function () {
        return this.url;
      }
    }